module.exports = __webpack_public_path__ + "media/images/steps/step_10-42940d44463a23af8096003d6098449c.svg";